import React from 'react'
import SubmitButton from '../SubmitButton'
import LinkLabel from '../LinkLabel'
import Layout from '../Layout'
import { PasswordResetSuccess } from '../../../assets/icons'
import { Text } from 'react-native-paper'
import { View } from 'react-native'
import { Spacer } from '../../../ui/atoms'
import {
  MESSAGE_TYPE,
  useMessage,
} from '../../../utils/helpers/MessageProvider'
import { SubTitle } from '../Title'
import SignInStore from '../stores/SignInStore'
import { paths } from '../../links'
import { ErrorMessage } from '../ErrorMessage'
import { Trans, useTranslation } from 'react-i18next'

export default function SigninForgotFinish({ navigation }) {
  const { setMessage } = useMessage()
  const { sendPasswordResetEmail, login, errors } = SignInStore
  const { t } = useTranslation('auth')
  const resendEmail = () => {
    SignInStore.removeError('forgot')
    sendPasswordResetEmail()
      .then(() => {
        setMessage(MESSAGE_TYPE.SUCCESS, 'Email has successfully sent')
      })
      .catch((e) => {
        console.log(e)
        SignInStore.setError('forgot', 'error', e.code)
      })
  }

  return (
    <Layout>
      <View style={{ flex: 1, alignItems: 'center' }}>
        <PasswordResetSuccess />
        <Text
          style={{
            fontWeight: '600',
            fontSize: 32,
            textAlign: 'center',
            width: '100%',
          }}
        >
          {t('signIn.forgotTitle2')}
        </Text>
        <Spacer height={30} />
        <SubTitle
          style={{
            textAlign: 'center',
            width: '100%',
            fontWeight: '500',
            color: '#668598',
          }}
        >
          {t('signIn.forgotSubTitle2')}
          {login}
        </SubTitle>
        <Spacer />
        <SubTitle
          style={{
            textAlign: 'center',
            width: '100%',
            fontWeight: '500',
            color: '#668598',
          }}
        >
          <Trans i18nKey={'signIn.forgotResendText'} t={t}>
            Didn't receive the email? Check your spam filter, or request to{' '}
            <LinkLabel onPress={resendEmail} testID="resend-email">
              resend email.
            </LinkLabel>
          </Trans>
        </SubTitle>
        <Spacer />
        <SubmitButton onPress={() => navigation.replace(paths.Auth.SignIn)}>
          {t('signIn.submitLabel')}
        </SubmitButton>
        <ErrorMessage error={errors.get('forgot')?.message} />
      </View>
    </Layout>
  )
}
